module.exports = __webpack_public_path__ + "img/list.488dbb14.png";